<template>
  <div class="start-screen">
    <h1 class="start-screen__title">
      Speel de Skip-Bo game!
    </h1>
    <div class="start-screen__intro">
      <p>
        Skip-Bo is een kaartspel met als doel om als eerste alle kaarten van de
        stok kwijt te raken. Dit doe je door de kaarten in de volgorde van 1 tot
        en met 12 weg te spelen. Het spel heeft geen vaste tijd, het is een spel
        dat lang kan duren, maar ook snel afgelopen kan zijn, afhankelijk van de
        kaarten die je hebt.
      </p>
      <p>
        Speel met minimaal 2 en maximaal 4 spelers. Bij de start van het spel
        krijgt elke speler 30 kaarten; 5 kaarten in "de hand" en 25 kaarten
        omgedraaid (dus niet zichtbaar) op de stok. De bovenste kaart is de
        eerste kaart die weggespeeld moet worden. Je moet alle kaarten van de
        stok wegspelen om te winnen!
      </p>
      <p>
        Het spel is vervolgens heel simpel. Diegene die aan de beurt is moet
        zorgen dat hij de bovenste kaart van zijn stok kan wegspelen. Daarvoor
        kunnen in het speelveld vier stapels neergelegd worden welke van 1 t/m
        12 lopen.
      </p>
      <p>
        Bij de beurt mag de speler zijn kaarten van "de hand", de stok en/of
        weggelegde kaarten aan het speelveld toevoegen. Bij de start van de
        beurt mag een speler zijn kaarten van "de hand" aanvullen tot 5; welke
        gepakt kunnen worden van de "trek" stapel. Als een speler tijdens een
        beurt zijn kaarten van "de hand" heeft weggelegd, dan mag deze vijf
        nieuwe kaarten van de "trek" stapel pakken. Zodra de speler geen kaart
        meer kan wegleggen, dient er een kaart op 1 van de 4 weglegplekken van
        de speler neerlegd worden. Daarna gaat de beurt over naar de volgende
        speler.
      </p>
      <p>
        De Skip-Bo kaarten zijn in principe jokers. Deze mogen ongeacht hoeveel
        en ongeacht welke kleur neergelegd worden in het speelveld. Je kan dus
        een stapel beginnen met 1 of juist gebruiken van 7,8 en 9. Een stapel in
        het speelveld moet altijd beginnen met 1, zodra deze wordt
        gecomplementeerd met 12 verdwijnt deze van het speelveld en kan er een
        nieuwe stapel begonnen worden.
      </p>
    </div>
    <h2>Selecteer aantal spelers</h2>
    <div class="start-screen__select">
      <CardSelection text="1" v-bind:activeValue="selectedPlayers >= 2" />
      <CardSelection
        text="2"
        v-on:selectedOption="selectPlayers(2)"
        v-bind:activeValue="selectedPlayers >= 2"
      />
      <CardSelection
        text="3"
        v-on:selectedOption="selectPlayers(3)"
        v-bind:activeValue="selectedPlayers >= 3"
      />
      <CardSelection
        text="4"
        v-on:selectedOption="selectPlayers(4)"
        v-bind:activeValue="selectedPlayers >= 4"
      />
    </div>
    <h2>Selecteer moeilijkheid/duur</h2>
    <div class="start-screen__select">
      <CardSelection
        text="makkelijk"
        v-on:selectedOption="selectDifficulty('easy')"
        v-bind:activeValue="selectedDifficulty === 'easy'"
      />
      <CardSelection
        text="gemiddeld"
        v-on:selectedOption="selectDifficulty('average')"
        v-bind:activeValue="selectedDifficulty === 'average'"
      />
      <CardSelection
        text="moeilijk"
        v-on:selectedOption="selectDifficulty('difficult')"
        v-bind:activeValue="selectedDifficulty === 'difficult'"
      />
    </div>
    <h2>Gebruik maken van Skip-Bo (jokers)?</h2>
    <div class="start-screen__select">
      <CardSelection
        text="ja"
        v-on:selectedOption="selectJokers(true)"
        v-bind:activeValue="selectedJokers"
      />
      <CardSelection
        text="nee"
        v-on:selectedOption="selectJokers(false)"
        v-bind:activeValue="!selectedJokers"
      />
    </div>
    <Button text="Start de game!" v-on:buttonClick="$router.push('board')" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CardSelection from '../components/shared/CardSelection';
import Button from '../components/shared/Button.vue';

export default {
  components: {
    CardSelection,
    Button
  },
  computed: mapState([
    'selectedPlayers',
    'selectedDifficulty',
    'selectedJokers'
  ]),
  methods: {
    selectPlayers(number) {
      this.$store.dispatch('setSelectedPlayers', number);
    },
    selectDifficulty(value) {
      this.$store.dispatch('setSelectedDifficulty', value);
    },
    selectJokers(bool) {
      this.$store.dispatch('setSelectedJokers', bool);
    }
  }
};
</script>

<style lang="scss" scoped>
.start-screen {
  &__title {
    margin-top: 0;
  }

  &__select {
    display: flex;
    width: calc(100% + 20px);
    margin: -10px;
  }
}
</style>
